import D2C_ServiceApp from './App'

class D2C_ServiceGo extends D2C_ServiceApp {
  static objectType = 'serviceType'
  static active = true
  static order = 15
  static typeName = 'go'
  static typeTitle = 'Go'
  static color = '#00aadd'
  static methods = {
    ...D2C_ServiceApp.methods,
    scale: true,
  }
  static fields = {
    ...D2C_ServiceApp.fields,
    deployCommands: {
      ...D2C_ServiceApp.fields.deployCommands,
      default: 'go build -o start_server',
    },
    env: {
      ...D2C_ServiceApp.fields.env,
      readonlyVariables: [
        {name: 'GOPATH', value: '/go'},
      ],
    },
    hosts: {
      ...D2C_ServiceApp.fields.hosts,
      selector: {
        default: ['node', 'node'],
      },
    },
    image: {
      ...D2C_ServiceApp.fields.image,
      default: 'golang',
    },
    ports: {
      ...D2C_ServiceApp.fields.ports,
      default: [
        {protocol: 'TCP', value: 3000},
      ],
    },
    source: {
      ...D2C_ServiceApp.fields.source,
      example: 'https://github.com/d2cio/go-hello-world',
    },
    startCommand: {
      default: './start_server',
      label: 'Command to start',
      path: 'startCommand',
      required: false,
      syntaxis: 'shell',
      validate() {
        return null
      },
      creating: {},
      importing: {},
      updating: {},
    },
    version: {
      ...D2C_ServiceApp.fields.version,
      default: '1.17',
      enum: ['1.14', '1.15', '1.16', '1.17'],
    },
    volumes: {
      ...D2C_ServiceApp.fields.volumes,
      demo: [
        {src: '/ebs/containers/$serviceName/sources', dst: '/go/src/$serviceName', sync: false},
      ],
    },
  }
}

export default D2C_ServiceGo
